import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import CheckboxGroup from "../../../ui/molecules/CheckBoxGroup"
import { CohesionType } from "./dataService/dto"
import { SelectCustom } from "../../../ui/molecules/select"
import Input from "../../../ui/molecules/input"
import { ProtocolSearch } from "../../../ui/molecules/ProtocolSearch"
import TextArea from "../../../ui/molecules/textArea"
import { ProdIntegrataNotType, regioniList, ProdIntegrataNotScopo, yes_no } from "../../../utils"
import { Calendar } from "../../../ui/molecules/calendar"
import { format } from "date-fns"
import { setUpdateAdhesionType, setUpdateType, setUpdateCampaignYear, setUpdateRegion, setUpdateNumber, setUpdateProtocol, setUpdateProtocolDate, setUpdateAdhesionDate, setUpdatePurpose, setUpdateRegionalMark, setUpdateConfirmId, setUpdateRettificationId, setUpdateProtocolId, setUpdateNote } from "./dataService/slice"

export function SqnpiEditForm() {
    const notificationSQNPIState = useAppSelector(state => state.NotificationSQNPI)
    const dispatch = useAppDispatch()
    const [selectedTypes, setSelectedTypes] = useState<CohesionType[]>([]);

    useEffect(() => {
        const currentTypes = [...selectedTypes];
        if (notificationSQNPIState.updateNotSQNPI?.adhesionTypes) {
            notificationSQNPIState.updateNotSQNPI.adhesionTypes.map((singleType) =>
                currentTypes.push(singleType)

            )
            setSelectedTypes(currentTypes)
        }
    }, [])

    const handleTypesChange = (value: CohesionType) => {
        let currentTypes = [...selectedTypes];
        if (currentTypes.includes(value)) {
            currentTypes = currentTypes.filter(t => t !== value)
        }
        else {
            currentTypes.push(value)
        }
        setSelectedTypes(currentTypes)
        dispatch(setUpdateAdhesionType(currentTypes))
    }

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>


                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                    <div style={{ flex: '0.3' }}>
                        <SelectCustom
                            label="Tipologia"
                            placeholder='Seleziona tipologia...'
                            value={notificationSQNPIState.updateNotSQNPI.type}
                            options={ProdIntegrataNotType}
                            onChange={(value) => dispatch(setUpdateType(value))}
                        />
                    </div>
                    <div style={{ flex: '0.3' }}>
                        <Input
                            label={'Anno Campagna'}
                            placeholder="Anno Campagna"
                            value={notificationSQNPIState.updateNotSQNPI.campaignYear}
                            onChangeText={(text) => dispatch(setUpdateCampaignYear(text))}
                        />
                    </div>
                    <div style={{ flex: '0.3' }}>
                        <SelectCustom
                            label="Regione"
                            placeholder='Regione'
                            value={notificationSQNPIState.updateNotSQNPI.region}
                            options={regioniList}
                            onChange={(value) => dispatch(setUpdateRegion(value))}
                        />
                    </div>
                </div>
                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                    <div style={{ flex: '0.3' }}>
                        <Input
                            label={'Numero'}
                            placeholder="Numero"
                            value={notificationSQNPIState.updateNotSQNPI.number}
                            onChangeText={(text) => dispatch(setUpdateNumber(text))}
                        />
                    </div>
                    <div style={{ flex: '0.3' }}>
                        <Input
                            label={'Protocollo'}
                            placeholder="Protocollo"
                            value={notificationSQNPIState.updateNotSQNPI.protocol}
                            onChangeText={(text) => dispatch(setUpdateProtocol(text))}
                        />
                    </div>
                    <div style={{ flex: '0.3' }}>
                        <Calendar
                            label="Data Protocollo"
                            selected={notificationSQNPIState.updateNotSQNPI.protocolDate}
                            onChange={(date) => dispatch(setUpdateProtocolDate(format(new Date(date), 'yyyy-MM-dd')))}
                        />
                    </div>

                </div>
                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                    <div style={{ flex: '0.3' }}>
                        <Calendar
                            label="Data Adesione"
                            selected={notificationSQNPIState.updateNotSQNPI.adhesionDate}
                            onChange={(date) => dispatch(setUpdateAdhesionDate(format(new Date(date), 'yyyy-MM-dd')))}
                        />
                    </div>
                    <div style={{ flex: '0.3' }}>
                        <SelectCustom
                            label="Scopo"
                            placeholder='Scopo'
                            value={notificationSQNPIState.updateNotSQNPI.purpose}
                            options={ProdIntegrataNotScopo}
                            onChange={(value) => dispatch(setUpdatePurpose(value))}
                        />
                    </div>
                    <div style={{ flex: '0.3' }}>
                        <SelectCustom
                            label="Marchio Regionale"
                            placeholder='Scegli'
                            options={yes_no}
                            value={
                                notificationSQNPIState.updateNotSQNPI.regionalMark ? 'SI' : 'NO'
                            }
                            onChange={(value) => dispatch(setUpdateRegionalMark(value))}
                        />
                    </div>
                </div>

                <div>
                    <div className='text-left mt-4'>
                        <div className="mb-3">
                            <span>Tipologia Adesione</span>
                        </div>
                        <div style={{ flex: '1', justifySelf: 'flex-start' }}>
                            <CheckboxGroup
                                name="tipo_adesione"
                                options={Object.values(CohesionType)}
                                selectedValues={selectedTypes}
                                onChange={handleTypesChange}
                                inline={true}
                                optionLabels={{
                                    [CohesionType.TERRENI]: "Terreno",
                                    [CohesionType.TRASFORMAZIONE_CONFEZIONAMENTO]: "Trasformazione / Confezionamento",
                                    [CohesionType.INTERMEDIAZIONE]: "Intermediazione",
                                    [CohesionType.COMMERCIALIZZAZIONE_PRODOTTO_SFUSO]: "Commercializzazione Prodotto Sfuso"
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="pb-2 mt-4" style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                    <div style={{ flex: '0.3' }}>
                        <SelectCustom
                            label="Conferma Domanda"
                            placeholder='Conferma Domanda'
                            value={notificationSQNPIState.updateNotSQNPI.sqnpiNotificationConfirmationId}
                            options={ProdIntegrataNotType}
                            onChange={(value) => dispatch(setUpdateConfirmId(value))}
                        />
                    </div>
                    <div style={{ flex: '0.3' }}>
                        <SelectCustom
                            label="Rettifica Domanda"
                            placeholder='Rettifica Domanda'
                            value={notificationSQNPIState.updateNotSQNPI.sqnpiNotificationRectificationId}
                            options={ProdIntegrataNotType}
                            onChange={(value) => dispatch(setUpdateRettificationId(value))}
                        />
                    </div>
                </div>

                <div className="pb-2 mt-4" >
                    <div>
                        <ProtocolSearch
                            type="entry"
                            value={notificationSQNPIState.updateNotSQNPI.requestProtocolId}
                            onSelect={(value) => dispatch(setUpdateProtocolId(value))}
                        />
                    </div>
                </div>

                <div className="pb-2 mt-4" >
                    <div>
                        <TextArea
                            value={notificationSQNPIState.updateNotSQNPI.note}
                            onChangeText={(text) => {
                                dispatch(setUpdateNote(text))
                            }} />
                    </div>
                </div>

            </div>
        </div>
    )


}